import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Box,
  Typography,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import DeleteIcon from '@mui/icons-material/Delete';

interface DeleteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  fileToDelete?: {
    id: number;
    type: 'image' | 'document';
    name?: string;
  } | null;
}

export default function PermanentDeleteModalFile({
  open,
  onClose,
  onConfirm,
  fileToDelete,
}: DeleteModalProps) {
  const fileTypeLabel = fileToDelete?.type === 'image' ? 'Bild' : 'Dokument';
  const fileName = fileToDelete?.name || `${fileTypeLabel} ${fileToDelete?.id}`;

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
        className: 'modal-dialog'
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="h6">
            {fileTypeLabel} löschen
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent className="modal-content">
        <DialogContentText className="modal-content-text">
          Sind Sie sicher, dass Sie diese Datei löschen möchten?
        </DialogContentText>
        
        {fileToDelete && (
          <Box sx={{ 
            my: 2, 
            p: 2, 
            border: '1px solid #e0e0e0', 
            borderRadius: 1,
            backgroundColor: '#f5f5f5'
          }}>
            <Typography variant="body2" color="textSecondary">
              <strong>Dateiname:</strong> {fileName}
            </Typography>
          </Box>
        )}
        
        <Box className="modal-info-box" sx={{ 
          mt: 2, 
          p: 2, 
          borderRadius: 1
        }}>
          <Typography className="modal-box-text" color="error">
            Die Datei wird gelöscht und kann später wiederhergestellt werden.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions className="modal-actions">
        <Button 
          onClick={onClose}
          className="modal-button modal-button-cancel"
          variant="outlined"
        >
          Abbrechen
        </Button>
        <Button
          onClick={onConfirm}
          className="modal-button modal-button-delete"
          variant="contained"
          color="error"
          startIcon={<DeleteIcon />}
        >
          Löschen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
